
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

const mustBePhoneNumber = (value) => {
    const val = value.replaceAll(' ', '');
    return /^([0-9]{10,})$/.test(val);
}

export default {
    head() {
        return {
            title: `ICFA - Journées portes ouvertes - ${this.instance?.attributes.name}`,
            meta: [
                {
                    hid: 'title',
                    property: 'title',
                    content: 'Journées portes ouvertes',
                },
                {
                    hid: 'description',
                    property: 'description',
                    content: `Journées portes ouvertes`,
                }
            ]
        };
    },
    data() {

        let jpoForm = {
            civilite: '',
            prenom: '',
            nom: '',
            telephone: '',
            email: '',
            diploma: '',
        };

        let jpoFormLabel = {
            civilite: 'Civilité',
            prenom: 'Prénom',
            nom: 'Nom',
            telephone: 'Téléphone',
            email: 'Email',
            diploma: 'Diplôme visé',
        };

        let formSent = false;
        let sending = false;

        const isOpen = false
        const dublon = false

        return {
            jpoForm,
            formSent,
            sending,
            isMounted: false,
            jpoFormLabel,
            errorForm: false,
            totalFormLabel: '',
            isOpen,
            dublon,
        }
    },
    setup() {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            jpoForm: {
                civilite: { required },
                prenom: { required },
                nom: { required },
                email: { required, email },
                telephone: { required, mustBePhoneNumber },
                diploma: { required },
            }

        }
    },

    mounted() {
        this.isMounted = true;
    },

    methods: {
        checkJpoForm() {
        },
        formUpdated() {
            if (this.v$.$errors.length && this.errorForm) {
                this.errorForm = true;
                this.totalFormLabel = '';
                let formInErrorTab = [];
                for (let error of this.v$.$errors) {
                    if (!formInErrorTab.includes(this.jpoFormLabel[error.$property])) {
                        formInErrorTab.push(this.jpoFormLabel[error.$property]);
                    }
                }

                this.totalFormLabel = formInErrorTab.join(', ');
            }
            else { this.errorForm = false; }
        },
        async sendStudent() {
            try {
                if (await this.v$.$validate()) {
                    this.sending = true;
                    this.errorForm = false;

                    // send url, diplomq ID and prefix of campus
                    this.jpoForm.campusDiplomaId = this.jpoForm.diploma.id;
                    this.jpoForm.url = window.location.host + "" + this.$nuxt.$route.path;
                    this.jpoForm.campusPrefix = this.instance.attributes.prefix;
                    this.jpoForm.utm = JSON.stringify(this.$store.state.utm);
                    let formData = new FormData();
                    let formToSend = JSON.parse(JSON.stringify(this.jpoForm));
                    formToSend.diplome = this.jpoForm.diploma.attributes.acronyme
                    formToSend.campus = this.instance.attributes.idCampusCRM


                    delete formToSend.diploma
                    formData.append('data', JSON.stringify(formToSend));

                    let result = await this.$http.$post(`${process.env.apiCrmServer}jpo-nuxt.php?`, formData);
                    if (result == "success") {
                        this.formSent = true;
                    } else if (result.code == 'alreadyExist') {
                        // display popup alreadyExist
                        this.sending = false;
                        this.dublon = true;
                        this.isOpen = true;
                    }
                    else {
                        this.sending = false;
                        this.isOpen = true
                    }

                } else {
                    this.sending = false;
                    this.errorForm = true;
                    this.formUpdated();
                }
            }
            catch (error) {
                this.sending = false;
                this.isOpen = true
            }
        },
    },
    async asyncData({ params, $http, store, redirect }) {
        let instance = store.state.instance;

        if (!instance) {
            let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
            instances = instances.data;

            instance = instances.filter((instance) => {
                return instance?.attributes.subFolderName == params.campusHP
            })[0];
        }

        if (!instance) {
            // redirect to lost page
            redirect('/404-error/')
        }
        let campusInfo = store.state.campusInfo;
        let detailInfo = store.state.detailInfo;

        // let campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance?.attributes.prefix}-diplomas?`);
        // campusDiplomas = campusDiplomas.data;
        let campusDiplomas = JSON.parse(JSON.stringify(store.state.campusDiplomas));
        const diplomaInfo = campusDiplomas.filter((diploma) => {
            return diploma?.attributes.acronyme == params.diploma
        })[0];

        let collone1Diplomas = campusDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_1';
        })
        collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })
        let collone2Diplomas = campusDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_2';
        })
        collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })
        let collone3Diplomas = campusDiplomas.filter((diploma) => {
            return diploma?.attributes.collone === 'Collone_3';
        })
        collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
            return d1?.attributes.ordre - d2?.attributes.ordre
        })

        let banniereLogoUrl = process.env.strapiBaseUri + campusInfo?.attributes.banniereLogo?.data?.attributes?.url;

        let jpoID = params.jpo.split('-').slice(-1)[0]
        let jpoInfo;
        try {
            jpoInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-jpos/${jpoID}`);
            jpoInfo = jpoInfo.data;
        }
        catch (error) {
            // redirect to lost page
            redirect('/404-error/')
        }

        return {
            instance, campusInfo, detailInfo, diplomaInfo, collone1Diplomas, collone2Diplomas,
            collone3Diplomas, banniereLogoUrl, campusDiplomas, jpoInfo
        }
    },

}
